import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyPages.css';

const TermsPage = () => {
    return (
        <div className='policy-page'>
            <div className='policy-hero'>
                <div className='container'>
                    <h1>Terms &amp; Conditions (Rahber Corporation, Since 1980)</h1>
                    <p>
                        Rules for using our website and purchasing from us.
                    </p>
                </div>
            </div>

            <div className='container policy-body'>
                <article className='policy-prose'>
                    <p className='lead'>
                        By using our website, you agree to the following terms.
                    </p>

                    <h2>1. General</h2>
                    <ul>
                        <li>
                            All content on this website is owned by Rahber
                            Corporation.
                        </li>
                        <li>Unauthorized use is strictly prohibited.</li>
                    </ul>

                    <h2>2. Product information</h2>
                    <ul>
                        <li>We try to ensure all product details are accurate.</li>
                        <li>
                            Errors may occur and can be corrected without notice.
                        </li>
                    </ul>

                    <h2>3. Pricing</h2>
                    <ul>
                        <li>All prices are listed clearly.</li>
                        <li>
                            We reserve the right to change prices at any time.
                        </li>
                    </ul>

                    <h2>4. Orders</h2>
                    <p>We reserve the right to cancel any order due to:</p>
                    <ul>
                        <li>Stock issues</li>
                        <li>Incorrect pricing</li>
                        <li>Suspicious activity</li>
                    </ul>

                    <h2>5. User responsibility</h2>
                    <ul>
                        <li>Customers must provide accurate information.</li>
                        <li>
                            Incorrect details may cause delays or failed
                            delivery.
                        </li>
                    </ul>

                    <h2>6. Limitation of liability</h2>
                    <ul>
                        <li>
                            We are not responsible for delays caused by
                            third-party courier services.
                        </li>
                        <li>We are not liable for indirect damages.</li>
                    </ul>

                    <h2>7. Policy updates</h2>
                    <p>
                        Rahber Corporation may update policies at any time
                        without prior notice.
                    </p>

                    <p>
                        Related: <Link to='/privacy'>Privacy Policy</Link>,{' '}
                        <Link to='/returns'>Returns &amp; Exchange</Link>,{' '}
                        <Link to='/contact'>Contact</Link>.
                    </p>
                </article>
            </div>
        </div>
    );
};

export default TermsPage;
